__turbopack_context__.v({
  "architectureDiagram": "homeRemote-module__VoLkrW__architectureDiagram",
  "claySpecimenGrid": "homeRemote-module__VoLkrW__claySpecimenGrid",
  "gridCaption": "homeRemote-module__VoLkrW__gridCaption",
  "imageGrid": "homeRemote-module__VoLkrW__imageGrid",
  "installerCaption": "homeRemote-module__VoLkrW__installerCaption",
  "installerImage": "homeRemote-module__VoLkrW__installerImage",
  "installerSection": "homeRemote-module__VoLkrW__installerSection",
  "installerWrapper": "homeRemote-module__VoLkrW__installerWrapper",
  "metaBlock": "homeRemote-module__VoLkrW__metaBlock",
  "metaGrid": "homeRemote-module__VoLkrW__metaGrid",
  "metaLabel": "homeRemote-module__VoLkrW__metaLabel",
  "metaLeft": "homeRemote-module__VoLkrW__metaLeft",
  "metaOverview": "homeRemote-module__VoLkrW__metaOverview",
  "metaRight": "homeRemote-module__VoLkrW__metaRight",
  "metaSection": "homeRemote-module__VoLkrW__metaSection",
  "metaText": "homeRemote-module__VoLkrW__metaText",
  "metaTools": "homeRemote-module__VoLkrW__metaTools",
  "page": "homeRemote-module__VoLkrW__page",
  "storySection": "homeRemote-module__VoLkrW__storySection",
  "tabsGrid": "homeRemote-module__VoLkrW__tabsGrid",
});
